import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { parse } from 'qs'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm, SubmissionError } from 'redux-form'

import actions from '../../../redux/actions'
import LoginHeader from '../header/login_header'
import TextLink from 'components/text_link/text_link'
import TextInputForm from 'components/input/text/text_input_form'
import CheckboxInputForm from 'components/input/checkbox/checkbox_input_form'
import TermsAndConditionsError from './terms_and_conditions_error'
import { MainButton } from 'components/button'
import { localize } from 'helpers/translator'
import errorCodes from 'helpers/enums/errorCodes'

import styles from './login_new_password.scss'

const validate = (values, props) => {
	const errors = {}
	if (!values.confirmPassword) {
		errors.confirmPassword = localize('global_form_requiredField')
	} else {
		if (values.password !== values.confirmPassword) {
			errors.confirmPassword = localize('logInNewPassword_passwordDontMatch')
		}
	}
	if (props.login.recoveryKey.mustAcceptTerms === '1' && !values.terms) {
		errors.terms = ' error_'
	}
	return errors
}

class LoginNewPassword extends Component {

	constructor(props) {
		super(props)
		this.handleNewPasswordSubmit = this.handleNewPasswordSubmit.bind(this)
	}

	componentDidMount() {
		let recoveryKey = this.props.login.recoveryKey.value
		const params = parse(location.search.substr(1))
		if (params.p) {
			this.props.actions.validateNewPasswordRecoveryKey(params.p)
			recoveryKey = params.p
		}
		this.props.actions.getSignupPasswordConditions(recoveryKey)
	}

	getFieldStatus = field =>
		(field.touched && field.invalid)
			? 'error'
			: ''

	getPasswordFieldStatus = field =>
		(field.touched && field.invalid)
			? 'error'
			: 'info'

	getPasswordFieldMessage = field =>
		(field.touched && field.invalid)
			? field.error
			: this.props.signup.passwordConditions.tooltip

	getConfirmPasswordMessage = field =>
		(field.touched && field.invalid)
			? field.error
			: ''

	validatePasswordField = value => {
		let error
		if (!value) {
			error = this.props.signup.passwordConditions.tooltip
		} else {
			this.props.signup.passwordConditions.validations.find(validation => {
				const regex = new RegExp(validation.regex)
				if (!regex.test(value)) {
					error = validation.text
					return error
				}
			})
		}
		return error
	}

	handleNewPasswordSubmit(values) {

		const params = parse(location.search.substr(1))
		let redirect = ''
		if (params.referer) {
			redirect = params.referer
		}
		const terms = (this.props.login.recoveryKey.mustAcceptTerms === '1') ? (!!values.terms) ? '1' : '0' : '1'
		const valuesObject = {
			password: values.password,
			terms,
			recoveryKey: this.props.login.recoveryKey.value,
			redirect,
		}
		return new Promise((resolve, reject) => {
			this.props.actions.sendNewPasswordForm(valuesObject, resolve, reject)
		})
			.then(() => {
			}).catch(err => {
				let error = err
				if (error.errorCode === errorCodes.RESET_PASSWORD_INVALID) {
					error = {
						password: this.props.signup.passwordConditions.tooltip,
					}
				}
				throw new SubmissionError(error)
			})
	}

	render() {
		let display = 'none'
		if (this.props.login.recoveryKey.isValid === true) {
			display = 'block'
		}

		const {
			error,
			handleSubmit,
			submitting } = this.props

		if (this.props.signup.passwordConditions !== null) {

			return (
				<div style={{display}}>
					<LoginHeader linkType='login' />
					<div className={styles.container}>
						<h2 className={styles.title}>{localize('logInNewPassword_title_2')}</h2>
						<form onSubmit={handleSubmit(this.handleNewPasswordSubmit)}>
							<div className={styles.input}>
								<Field
									name="password"
									component={TextInputForm}
									props={{
										type: 'password',
										placeholder: localize('global_form_password'),
										fieldStatus: this.getPasswordFieldStatus,
										getMessage: this.getPasswordFieldMessage,
										maxLength: this.props.signup.passwordConditions.maxLength,
										icons: {
											active: true,
										},
										ariaLabel: 'Password',
										tabindex: 0,
									}}
									validate={[this.validatePasswordField]}
								/>
							</div>
							<div className={styles.input}>
								<Field
									name="confirmPassword"
									component={TextInputForm}
									props={{
										type: 'password',
										placeholder: localize('global_form_confirmPassword'),
										fieldStatus: this.getFieldStatus,
										getMessage: this.getConfirmPasswordMessage,
										maxLength: this.props.signup.passwordConditions.maxLength,
										icons: {
											active: true,
										},
										ariaLabel: 'Confirm password',
										tabindex: 1,
									}}
								/>
							</div>
							{this.props.login.recoveryKey.mustAcceptTerms === '1' && <div className={styles.disclaimer}>
								<span className={styles.disclaimer_checkbox}>
									<Field
										name="terms"
										component={CheckboxInputForm}
										props={{
											fieldStatus: this.getFieldStatus,
											ariaChecked: false,
											ariaLabel: '',
											tabindex: 3,
										}}
									/>
								</span>
								<p className={styles.disclaimer_text}>
									{localize('signUp_terms_start')}
									&nbsp;
									<TextLink className={styles.link} href='https://nearpod.com/terms-conditions' target='_blank' linkClick={this.props.navigateToTerms}>
										{localize('signUp_terms_link')}
									</TextLink>
									&nbsp;
									{localize('signUp_terms_end')}.
								</p>
								<Field
									name="terms"
									component={TermsAndConditionsError}
									props={{
										style_data: styles.disclaimer_error,
									}}
								/>
							</div>}
							<MainButton type='submit' disabled={submitting}>{localize('global_submit')}</MainButton>
							{error && <div className={styles.error}>{error}</div>}
						</form>
					</div>
				</div>
			)
		} else {
			return null
		}
	}

}

LoginNewPassword.propTypes = {
	actions: PropTypes.object,
	login: PropTypes.object,
	signup: PropTypes.object,
	handleSubmit: PropTypes.func.isRequired,
	error: PropTypes.string,
	submitting: PropTypes.bool.isRequired,
}

LoginNewPassword = reduxForm({
	form: 'NewPassword',
	fields: ['password', 'confirmPassword', 'terms'],
	validate,
})(LoginNewPassword)

function mapStateToProps(state) {
	return {
		login: state.login,
		signup: state.signup,
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginNewPassword)
